import styled from 'styled-components'

export const Icon = styled.i`
  font-weight: 900;
  font-size: 19px;
  line-height: 19px;
  color: #0076B4;
  margin-right: 10px;
`